<template>
  <div class="v2026-svcbadges" v-if="badges.length">
    <span class="v2026-svcbadges__label">{{ label }}</span>
    <div class="v2026-svcbadges__row">
      <img v-for="(badge, index) in badges" :key="index"
           class="v2026-svcbadges__ico"
           v-b-tooltip.hover :title="badge.title"
           :src="badge.src" :alt="badge.title">
    </div>
  </div>
</template>

<script>
const SERVICE_ICONS = {
  vacuum: require('@/assets/img/badge-vacuum-cleaner.svg'),
  cleaning: require('@/assets/img/cleaning.png'),
  iron: require('@/assets/img/iron.png'),
  car: require('@/assets/img/sport-car.png'),
  scooter: require('@/assets/img/scooter.png'),
  bus: require('@/assets/img/school-bus.png'),
  syringe: require('@/assets/img/syringe.png'),
  excellent: require('@/assets/img/ic_badge_excellent.png')
}

export default {
  name: 'service-badges-v2026',
  props: {
    // null → no badges → the component hides itself.
    professional: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: 'บริการ & คุณสมบัติ'
    }
  },
  computed: {
    badges () {
      const p = this.professional
      if (!p) return []
      const s = SERVICE_ICONS
      const badges = []
      if (p.has_vacuum_cleaner) badges.push({ src: s.vacuum, title: 'มีเครื่องดูดฝุ่น' })
      if (p.cleaning_service === 1) badges.push({ src: s.cleaning, title: 'บริการทำความสะอาด' })
      if (p.ironing_service === 1) badges.push({ src: s.iron, title: 'บริการรีดผ้า' })
      if (p.transportation_type) {
        const t = p.transportation_type.name_th
        if (t === 'รถยนต์ส่วนตัว') badges.push({ src: s.car, title: 'มีรถยนต์ส่วนตัว' })
        if (t === 'รถจักรยานยนต์') badges.push({ src: s.scooter, title: 'มีรถจักรยานยนต์' })
        if (t === 'รถขนส่งสาธารณะ') badges.push({ src: s.bus, title: 'เดินทางรถขนส่งสาธารณะ' })
      }
      if (p.vaccinated) badges.push({ src: s.syringe, title: 'ฉีดวัคซีนแล้ว' })
      if (p.is_excellent === 1) badges.push({ src: s.excellent, title: 'ผู้ให้บริการยอดเยี่ยม' })
      return badges
    }
  }
}
</script>

<style scoped>
.v2026-svcbadges {
  --v2026-svcbadges-text-secondary: #667085;

  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 16px;
}

.v2026-svcbadges__label {
  font-size: 13px;
  font-weight: 600;
  color: var(--v2026-svcbadges-text-secondary);
}

.v2026-svcbadges__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.v2026-svcbadges__ico {
  width: 32px;
  height: 32px;
  object-fit: contain;
}
</style>
